import { TeamData } from '../api/types/TeamData';

export class TeamVm {
    constructor(teamData: TeamData) {
        this.teamId = teamData.teamId;
        this.name = teamData.name;
        this.nickname = teamData.nickname;
        this.displayName = teamData.displayName;
        this.shortName = teamData.shortName;
        this.fullName = teamData.fullName;
        this.svgLogo = teamData.svgLogo;
    }

    teamId: number;
    name: string;
    nickname: string;
    displayName: string;
    shortName: string;
    fullName: string;
    svgLogo: string;
}